import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { TabelaPrecoService } from 'src/app/services/http/tabela-preco.service';
import { distinctUntilChanged, debounceTime, first, startWith } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Usuario } from 'src/app/models/usuario-login';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-list-tabela-preco',
  templateUrl: './list-tabela-preco.component.html',
  styleUrls: ['./list-tabela-preco.component.scss']
})
export class ListTabelaPrecoComponent implements OnInit {

  
  listaTabelaPreco = [];
  total = 0;
  
  form = new FormGroup({
    id: new FormControl(''),
    nome: new FormControl(''),
    descricao: new FormControl('')
  });

  search = {
    filter: {
      id: '',
      nome: '',
      descricao: '',
    },
    sorting: {
      id: '',
      nome: 'desc',
      descricao: ''
    },
    per_page: 10,
    page: 1,
    data: new Date()
  };

  uuid: any;
  usuario;
  tabelaPadrao;

  first: number = 0;
  object: any = {};
  dynamicdownloadName: string = "Consulta - Tabela de Preços"

  cols: any = [
    { field: 'id', header: '#'},
    { field: 'nome', header: 'Nome' },
    { field: 'descricao', header: 'Descrição' },
  ];

  constructor(private tabelaPrecoService: TabelaPrecoService, private loginService: LoginService, private route: Router, private modalMsgService: ModalMsgService) {
  }

  ngOnInit() {
    this.loginService.getLogIn().pipe(first()).subscribe(r => {
      this.usuario = r;
    })

    this.tabelaPrecoService.getTabelaPadrao().then( r => this.tabelaPadrao = r.uuid);

    this.form.valueChanges.pipe(startWith(this.form.value), distinctUntilChanged(), debounceTime(800)).subscribe(v => {
      this.search.filter = v;
      this.getListaTabela();
    });
  }

  removerTabela(tabela) {
    this.modalMsgService.justificativa('Remover tabela de preço').then(justificativa => {
        this.tabelaPrecoService.excluirTabelaPreco(tabela, 'justificativa').then(r => {
          if( r['success'] ){
            this.modalMsgService.openDialog(r['message'], '', 'success')
            this.getListaTabela();
          }else{
            this.modalMsgService.openDialog(r['message'], '', 'warning')
          }
        });
    }).catch(e => e);
  }

  getListaTabela() {
    this.tabelaPrecoService.listarTabelaPreco(this.search).then(r => {
      this.listaTabelaPreco = r.lista;
      this.total = r.total;
    });
  }

  setOrder() {
    this.getListaTabela();
  }

  setPageSize(size) {
    this.search.per_page = size;

    this.getListaTabela();
  }

  pageChange() {
    this.getListaTabela();
  }

  getTabelaPadrao() {
    this.tabelaPrecoService.getTabelaPadrao().then(r => {
      this.uuid = r['uuid'];
      if(this.uuid) {
        this.tabelaPrecoService.getTabelaPreco(this.uuid);
        this.route.navigate(['tabela-preco','editar', this.uuid]);
      }
    });
  }

}
